import { render, staticRenderFns } from "./InventoryExportData.vue?vue&type=template&id=36f7e069&scoped=true"
import script from "./InventoryExportData.vue?vue&type=script&lang=ts"
export * from "./InventoryExportData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f7e069",
  null
  
)

export default component.exports